import "@/index.css";
import "./i18n";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./contexts/AuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { Layout } from "./components/Layout";

// Pages
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import DashboardPage from "./pages/DashboardPage";
import PropertiesPage from "./pages/PropertiesPage";
import PropertyDetailPage from "./pages/PropertyDetailPage";
import BrokersPage from "./pages/BrokersPage";
import ImportPage from "./pages/ImportPage";
import ExportPage from "./pages/ExportPage";
import EmbedPage from "./pages/EmbedPage";
import UsersPage from "./pages/UsersPage";
import PublicSearchPage from "./pages/PublicSearchPage";
import PublicPropertyDetailPage from "./pages/PublicPropertyDetailPage";
import EmbedSinglePropertyPage from "./pages/EmbedSinglePropertyPage";
import FTPConfigPage from "./pages/FTPConfigPage";
import InquiriesPage from "./pages/InquiriesPage";
import ProfilePage from "./pages/ProfilePage";
import AnalyticsPage from "./pages/AnalyticsPage";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/embed" element={<PublicSearchPage />} />
          <Route path="/search" element={<PublicSearchPage />} />
          <Route path="/expose/:id" element={<PublicPropertyDetailPage />} />
          <Route path="/embed/property/:id" element={<EmbedSinglePropertyPage />} />
          
          {/* Protected Routes */}
          <Route path="/dashboard" element={
            <ProtectedRoute>
              <Layout><DashboardPage /></Layout>
            </ProtectedRoute>
          } />
          <Route path="/properties" element={
            <ProtectedRoute>
              <Layout><PropertiesPage /></Layout>
            </ProtectedRoute>
          } />
          <Route path="/properties/:id" element={
            <ProtectedRoute>
              <Layout><PropertyDetailPage /></Layout>
            </ProtectedRoute>
          } />
          <Route path="/brokers" element={
            <ProtectedRoute>
              <Layout><BrokersPage /></Layout>
            </ProtectedRoute>
          } />
          <Route path="/import" element={
            <ProtectedRoute>
              <Layout><ImportPage /></Layout>
            </ProtectedRoute>
          } />
          <Route path="/export" element={
            <ProtectedRoute>
              <Layout><ExportPage /></Layout>
            </ProtectedRoute>
          } />
          <Route path="/embed-config" element={
            <ProtectedRoute>
              <Layout><EmbedPage /></Layout>
            </ProtectedRoute>
          } />
          <Route path="/users" element={
            <ProtectedRoute requireAdmin>
              <Layout><UsersPage /></Layout>
            </ProtectedRoute>
          } />
          <Route path="/ftp-sync" element={
            <ProtectedRoute>
              <Layout><FTPConfigPage /></Layout>
            </ProtectedRoute>
          } />
          <Route path="/inquiries" element={
            <ProtectedRoute>
              <Layout><InquiriesPage /></Layout>
            </ProtectedRoute>
          } />
          <Route path="/profile" element={
            <ProtectedRoute>
              <Layout><ProfilePage /></Layout>
            </ProtectedRoute>
          } />
          <Route path="/analytics" element={
            <ProtectedRoute>
              <Layout><AnalyticsPage /></Layout>
            </ProtectedRoute>
          } />
          
          {/* Redirects */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
